import { CSSProperties, HTMLAttributes, ReactNode, useDeferredValue, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
// import { ReactComponent as NewFolder } from '../../../assets/img/storage/actions-new-folder.svg';
import Highlighter from 'react-highlight-words';
import { ReactComponent as MobileFilterIcon } from '../../../assets/img/storage/filter-mobile.svg';

import { t } from 'i18next';
import { Trans } from 'react-i18next';
import ShareIcon from '../../../assets/img/storage/list-share.svg';
import { ReactComponent as ListSort } from '../../../assets/img/storage/list-sort.svg';
import { ReactComponent as ArrowDown } from '../../../assets/svg/ArrowDown.svg';
import { ReactComponent as Grid } from '../../../assets/svg/controls-storage-grid.svg';
import { ReactComponent as List } from '../../../assets/svg/controls-storage-list.svg';
import { toMplatBackendDate } from '../../../components/common';
import { DatePicker } from '../../../components/mplat/DatePicker';
import { useOutsideAlerter } from '../../../hooks';

interface StorageFilterPeopleProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: any[],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    options: { label?: string, value: any, color?: boolean | string, disabled?: boolean, custom?: string }[],
    placeholder?: string,
    className?: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange?: (value: any[]) => void,
    disabled?: boolean,
}

export function StorageFilterPeople({ value, options, placeholder, className, onChange, disabled }: StorageFilterPeopleProps) {
    const refDiv = useRef<HTMLDivElement | null>(null);

    const [label, setLabel] = useState<string>('');
    const [val, setVal] = useState<string[]>(value);
    const [isExpand, setIsExpand] = useState(false);

    const [filter, setFilter] = useState('');
    const deferredFilter = useDeferredValue(filter);
    const linkOption = { value: 'link', label: 'link' };
    const [effectiveOptions, setEffectiveOptions] = useState(options);
    const [filteredOptions, setFilteredOptions] = useState(options);

    useEffect(() => {
        setEffectiveOptions(options);
        const tmp = options.filter(o => val.includes(o.value)).concat(val.includes('link') ? [linkOption] : []);
        setLabel(tmp.length ? tmp.length.toString() : '');
    }, [options, value]);

    useEffect(() => {
        setFilteredOptions(effectiveOptions
            .filter(o => o.label) // фильтруем пустые строки
            .filter(o => !deferredFilter || o.label?.toLowerCase().includes(deferredFilter.toLowerCase())));
    }, [deferredFilter, effectiveOptions]);

    useOutsideAlerter(refDiv, setIsExpand);
    return (
        <div
            ref={refDiv}
            className={`storage__filters-item _users ${isExpand ? '_show' : ''} ${val.length > 0 ? '_active' : ''} ${className || ''}`}
            onClick={() => {
                if (disabled) return;
                setIsExpand(!isExpand);
            }}
        >
            <div className="storage__filters-item-label">
                <div className="storage__filters-item-label-text">
                    {placeholder}{label ? ` · ${label}` : ''}
                </div>
                <div className="storage__filters-item-label-icon">
                    <ArrowDown />
                </div>
            </div>
            <div className="storage__filters-item-list" onClick={(e) => e.stopPropagation()}>
                <div className="storage__filters-item-list-search">
                    <input value={filter} onChange={(e) => setFilter(e.target.value)} type="text" className="storage__filters-item-list-search-input" placeholder="Поиск людей или групп" />
                </div>
                <div className="storage__filters-item-list-users">
                    {filteredOptions.map((option) => (
                        <div
                            key={option.value}
                            className={`storage__filters-item-list-item ${val.includes(option.value) ? '_active' : ''}`}
                            onClick={() => {
                                if (disabled) return;
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                let tmp: any[] = [];
                                if (!val.includes(option.value)) {
                                    tmp = [...val, option.value];
                                    setVal(tmp);
                                } else {
                                    tmp = val.filter(v => v !== option.value);
                                    setVal(tmp);
                                }
                                const selectedOptions = effectiveOptions.filter(o => tmp.includes(o.value));
                                onChange && onChange(selectedOptions);
                                const selectedCount = selectedOptions.length + (tmp.includes('link') ? 1 : 0);
                                setLabel(selectedCount ? selectedCount.toString() : '');
                            }}
                        >
                            <div className="storage__filters-item-list-item-name">{option.label}</div>
                            <div className="storage__filters-item-list-item-type">{option.custom}</div>
                        </div>
                    ))}

                    {/* <div className="storage__filters-item-list-item" data-value="2">
                        <div className="storage__filters-item-list-item-name">Продюсерская компания Творческое Министерство</div>
                        <div className="storage__filters-item-list-item-type">группа</div>
                    </div>
                    <div className="storage__filters-item-list-item" data-value="3">
                        <div className="storage__filters-item-list-item-name">@newchannal</div>
                        <div className="storage__filters-item-list-item-type">аккаунт</div>
                    </div>
                    <div className="storage__filters-item-list-item" data-value="4">
                        <div className="storage__filters-item-list-item-name">@mediabaza</div>
                        <div className="storage__filters-item-list-item-type">аккаунт</div>
                    </div> */}
                </div>
                <div className={`storage__filters-item-list-item ${val.includes('link') ? '_active' : ''}`} onClick={() => {
                    if (disabled) return;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    let tmp: any[] = [];
                    if (!val.includes('link')) {
                        tmp = [...val, 'link'];
                        setVal(tmp);
                    } else {
                        tmp = val.filter(v => v !== 'link');
                        setVal(tmp);
                    }
                    const selectedOptions = effectiveOptions.filter(o => tmp.includes(o.value));
                    onChange && onChange(selectedOptions);
                    const selectedCount = selectedOptions.length + (tmp.includes('link') ? 1 : 0);
                    setLabel(selectedCount ? selectedCount.toString() : '');
                }}>
                    <img src={ShareIcon} alt="" />
                    Все у кого есть ссылка
                </div>
            </div>
        </div>
    )
}

interface StorageFilterItemProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    options: { label?: string, value: any, color?: boolean | string, disabled?: boolean, icon?: ReactNode }[],
    radio?: boolean,
    dateWithCustom?: boolean,
    placeholder?: string,
    className?: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange?: (value: any) => void,
    onChangeCustom?: (since: Date, till: Date) => void,
    disabled?: boolean,
    children?: React.ReactNode,
    style?: CSSProperties,
    containerStyle?: CSSProperties,
}

export function StorageFilterItem({ value, options, children, className, containerStyle, disabled, onChange, onChangeCustom, placeholder, radio, style, dateWithCustom }: StorageFilterItemProps) {
    const refDiv = useRef<HTMLDivElement | null>(null);

    const [label, setLabel] = useState<string>();
    const [val, setVal] = useState<string>(value);
    const [isExpand, setIsExpand] = useState(false);
    const [showCustom, setShowCustom] = useState(false);
    const [filter, setFilter] = useState('');

    const [customSinceDate, setCustomSinceDate] = useState<Date | undefined>(undefined);
    const [customTillDate, setCustomTillDate] = useState<Date | undefined>(undefined);

    useOutsideAlerter(refDiv, setIsExpand);

    useEffect(() => {
        customSinceDate && customTillDate && onChangeCustom && onChangeCustom(customSinceDate, customTillDate);
    }, [customSinceDate, customTillDate]);

    useEffect(() => {
        if (!isExpand) {
            setFilter('');
        } else {
            refDiv.current?.focus();
        }
    }, [isExpand]);

    useEffect(() => {
        if (showCustom) {
            if (!customSinceDate) {
                const lastMonth = new Date();
                lastMonth.setMonth(lastMonth.getMonth() - 1)
                setCustomSinceDate(lastMonth);
            }
            if (!customTillDate) {
                const now = new Date();
                setCustomTillDate(now);
            }
            setVal('custom'); onChange && onChange('custom');
        }
    }, [showCustom])

    return (
        <div
            ref={refDiv}
            className={`storage__filters-item _list ${isExpand ? '_show' : ''} ${val ? '_active' : ''} ${dateWithCustom ? '_date' : ''} ${showCustom ? '_custom' : ''} ${className || ''}`}
            style={containerStyle}
            onClick={() => {
                if (disabled) return;
                setIsExpand(!isExpand);
            }}
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === 'Escape') {
                    setIsExpand(false);
                }/* else if (e.key === 'Backspace') {
                    setFilter((prev) => prev.slice(0, prev.length - 1));
                } else if (e.key.length === 1) {
                    setFilter((prev) => prev + e.key);
                }*/
            }}
        >
            <div className="storage__filters-item-label" >
                <div className="storage__filters-item-label-text">
                    {placeholder}{showCustom ? (` · ${toMplatBackendDate(customSinceDate, true)} — ${toMplatBackendDate(customTillDate, true)}`) : ((value && label) ? ` · ${label}` : '')}
                </div>
                <div className="storage__filters-item-label-icon">
                    <ArrowDown />
                </div>
            </div>
            <div className="storage__filters-item-list" style={style}>
                <div className="storage__filters-item-list-search">
                    <input
                        autoFocus
                        className="storage__filters-item-list-search-input"
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                        placeholder={t('Search')}
                        onClick={(e) => e.stopPropagation()}
                    />
                </div>
                <div className="storage__filters-item-list-inner">
                    {options.filter(o => !filter || o.label?.toLowerCase().includes(filter.toLowerCase())).map((option) => (
                        <div className={`storage__filters-item-list-item ${(radio && option.value === val) ? '_active' : ''}`}
                            key={option.value}
                            onClick={() => {
                                if (option.value !== val) {
                                    setVal(option.value);
                                    setLabel(option.label);
                                    onChange && onChange(option.value);
                                } else {
                                    setVal('');
                                    setLabel(undefined);
                                    onChange && onChange('');
                                }
                            }}
                            style={{ color: option.color ? (option.color === true ? option.value : option.color) : undefined }}
                        >
                            {option.icon}
                            {option.label}
                        </div>
                    ))}
                    {dateWithCustom && (
                        <>
                            <div className="storage__filters-item-list-sep" />
                            <div className="storage__filters-item-list-item" onClick={(e) => { e.stopPropagation(); setShowCustom(true) }}>
                                <Trans>Custom date range</Trans>
                            </div>
                        </>
                    )}
                </div>
                {dateWithCustom && showCustom && (
                    <div className="storage__filters-item-dates">
                        <div className="storage__filters-item-dates-heading">
                            <Trans>Custom date range</Trans>
                        </div>
                        <div className="storage__filters-item-dates-body" onClick={(e) => e.stopPropagation()}>
                            <Trans>since</Trans>
                            <DatePicker closeOnActivate simple value={customSinceDate} setValue={(v) => { setCustomSinceDate(v); }} fullSize />
                            <Trans>till</Trans>
                            <DatePicker closeOnActivate simple value={customTillDate} setValue={(v) => { setCustomTillDate(v); }} fullSize />
                        </div>
                        <div className="storage__filters-item-dates-cta">
                            <button
                                className="btn _min storage__filters-item-dates-cta-apply"
                                onClick={() => { setVal('custom'); onChange && onChange('custom'); }}
                            >
                                <Trans>Apply</Trans>
                            </button>
                            <button
                                className="storage__filters-item-dates-cta-cancel"
                                onClick={() => {
                                    setVal('');
                                    setLabel(undefined);
                                    onChange && onChange('');
                                    setShowCustom(false);
                                    setCustomSinceDate(undefined);
                                    setCustomTillDate(undefined);
                                }}
                            >
                                <Trans>Cancel</Trans>
                            </button>
                        </div>
                    </div>
                )}
            </div>
            {children}
        </div>
    )
}

interface StorageMultiFilterItemProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: any[],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    options: { label: string, value: any, color?: boolean | string, disabled?: boolean, icon?: ReactNode }[],
    placeholder?: string,
    className?: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange?: (value: any) => void,
    disabled?: boolean,
    children?: React.ReactNode,
    style?: CSSProperties,
    containerStyle?: CSSProperties,
}

export function StorageMultiFilterItem({ value, options, children, className, containerStyle, disabled, onChange, placeholder, style }: StorageMultiFilterItemProps) {
    const refDiv = useRef<HTMLDivElement | null>(null);

    const [labels, setLabels] = useState<string[]>([]);
    const [val, setVal] = useState<string[]>(value);
    const [isExpand, setIsExpand] = useState(false);

    useOutsideAlerter(refDiv, setIsExpand);

    useEffect(() => {
        setVal(value);
    }, [value]);

    return (
        <div
            ref={refDiv}
            className={`storage__filters-item ${isExpand ? '_show' : ''} ${val.length ? '_active' : ''} ${className || ''}`}
            style={containerStyle}
            onClick={() => {
                if (disabled) return;
                setIsExpand(!isExpand);
            }}
        >
            <div className="storage__filters-item-label" >
                <div className="storage__filters-item-label-text">
                    {value.length ? (labels.length < 3 ? labels.join(', ') : `${placeholder} · ${labels.length}`) : placeholder}
                </div>
                <div className="storage__filters-item-label-icon">
                    <ArrowDown />
                </div>
            </div>
            <div className="storage__filters-item-list" style={style}>
                <div className="storage__filters-item-list-body">
                    {options.map((option) => (
                        <div className={`storage__filters-item-list-item ${(val.includes(option.value)) ? '_active' : ''}`}
                            key={option.value}
                            onClick={(e) => {
                                e.stopPropagation();
                                if (disabled) return;
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                let tmp: any[] = [];
                                if (!val.includes(option.value)) {
                                    tmp = [...val, option.value];
                                    setVal(tmp);
                                } else {
                                    tmp = val.filter(v => v !== option.value);
                                    setVal(tmp);
                                }
                                onChange && onChange(tmp);
                                setLabels(options.filter((o) => tmp.includes(o.value)).map((o) => o.label));
                            }}
                            style={{ color: option.color ? (option.color === true ? option.value : option.color) : undefined }}
                        >
                            {option.icon}
                            {option.label}
                        </div>
                    ))}
                </div>
            </div>
            {children}
        </div>
    )
}

interface StorageSearcherResult {
    value: string,
    className: string,
}

interface StorageSearcherProps {
    placeholder?: string,
    value?: string,
    onChange?: (v: string) => void,
    results?: StorageSearcherResult[],
}

export function StorageSearcher({ value, placeholder, onChange, results }: StorageSearcherProps) {
    const wrapperRef = useRef(null);
    const [localValue, setLocalValue] = useState(value || '');
    const [showResults, setShowResults] = useState(false);

    useEffect(() => {
        setShowResults((prev) => prev || !!value);
        setLocalValue(value || '');
    }, [value]);

    useOutsideAlerter(wrapperRef, setShowResults);

    return (
        <div ref={wrapperRef} className="storage__filters-search">
            <input
                type="text"
                value={localValue}
                className="storage__filters-search-input"
                placeholder={placeholder || `${t('Search')}...`}
                onKeyDown={(e) => {
                    if (e.key === 'Escape' && showResults) {
                        setTimeout(() => setShowResults(false), 50);
                    } else if (e.key === 'Enter' && showResults) {
                        // setLocalValue(results[0].value);
                        // onChange && onChange(results[0].value);
                        setTimeout(() => setShowResults(false), 50);
                    }
                }}
                onChange={(e) => {
                    setLocalValue(e.target.value || '');
                    onChange && onChange(e.target.value);
                }}
            />
            <div
                className="storage__filters-search-results"
                style={{ display: (showResults && results && results.length > 0) ? 'block' : 'none' }}
            >
                {results && results.map((result) => (
                    <span
                        key={result.value}
                        className={`storage__filters-search-results-item ${result.className || '_folder'}`}
                        onClick={() => { setLocalValue(result.value); onChange && onChange(result.value); setShowResults(false); }}
                    >
                        <Highlighter
                            highlightClassName={`${'_folder'}`}
                            searchWords={[localValue]}
                            autoEscape={true}
                            highlightTag={'strong'}
                            textToHighlight={result.value}
                        />
                    </span>))}
            </div>
        </div>
    )
}

interface StorageSorterProps {
    value: string,
    options: { value: string, label: string }[],
    onChange: (v: string) => void
}

export function StorageSorter({ value, options, onChange }: StorageSorterProps) {
    const [show, setShow] = useState(false);
    const [localValue, setLocalValue] = useState(value);
    const [label, setLabel] = useState(options.find((opt) => opt.value === value)?.label || '');
    const [direction, setDirection] = useState<'asc' | 'desc'>('asc');

    const refWrapper = useRef<HTMLDivElement | null>(null);

    useOutsideAlerter(refWrapper, setShow);

    useEffect(() => {
        onChange(`${direction === 'asc' ? '' : '-'}${localValue}`);
    }, [localValue, direction]);

    useEffect(() => {
        if (value.startsWith('-')) {
            const opt = options.find((o) => o.value === value.slice(1));
            if (opt) {
                setLabel(opt.label)
                setLocalValue(opt.value);
                setDirection('desc');
            }
        } else {
            const opt = options.find((o) => o.value === value);
            if (opt) {
                setLabel(opt.label)
                setLocalValue(opt.value);
                setDirection('asc');
            }
        }
    }, [value]);

    return (
        <div ref={refWrapper} className={`storage__filters-item _sort ${show && '_show'}`} onClick={() => setShow(!show)}>
            <div className="storage__filters-item-label">
                <div className={`storage__filters-item-label-text ${direction === 'asc' ? '_asc' : '_desc'}`}><Trans>storage:SORT_BY</Trans> {label.toLowerCase()}</div>
                <div className="storage__filters-item-label-icon">
                    <ListSort />
                </div>
            </div>
            <div className="storage__filters-item-list">
                <div className="storage__filters-item-group">
                    {options.map((opt) => (
                        <div
                            key={opt.value}
                            className={`storage__filters-item-list-item${opt.value === localValue ? ' _active' : ''}`}
                            onClick={() => { setLocalValue(opt.value); setLabel(opt.label) }}
                        >
                            {opt.label}
                        </div>
                    ))}
                </div>
                <div className="storage__filters-item-list-sep" />
                <div className="storage__filters-item-group">
                    <div className={`storage__filters-item-list-item ${direction === 'asc' && '_active'}`} onClick={() => setDirection('asc')}>
                        <Trans>storage:SORT_ASC</Trans>
                    </div>
                    <div className={`storage__filters-item-list-item ${direction === 'desc' && '_active'}`} onClick={() => setDirection('desc')}>
                        <Trans>storage:SORT_DESC</Trans>
                    </div>
                </div>
            </div>
        </div>
    );
}

interface StorageViewProps {
    mode: 'list' | 'grid',
    setMode: (v: 'list' | 'grid') => void,
}

export function StorageView({ mode, setMode }: StorageViewProps) {
    return (
        <div className="storage__filters-view">
            {mode === 'grid' ?
                <span className="storage__filters-view-item _active" title={t('storage:GRID')}>
                    <Grid />
                    <span className="storage__filters-view-item-label">
                        <Trans>storage:GRID</Trans>
                    </span>
                </span>
                :
                <Link to="" className="storage__filters-view-item" title={t('storage:GRID')} onClick={(e) => { e.preventDefault(); setMode('grid') }}>
                    <Grid />
                    <span className="storage__filters-view-item-label">
                        <Trans>storage:GRID</Trans>
                    </span>
                </Link>
            }
            {mode === 'list' ?
                <span className="storage__filters-view-item _active" title={t('List')}>
                    <List />
                    <span className="storage__filters-view-item-label">
                        <Trans>List</Trans>
                    </span>
                </span>
                :
                <Link to="" className="storage__filters-view-item" title={t('List')} onClick={(e) => { e.preventDefault(); setMode('list') }}>
                    <List />
                    <span className="storage__filters-view-item-label">
                        <Trans>List</Trans>
                    </span>
                </Link>
            }
        </div>
    )
}

interface StorageFiltersProps extends HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode,
    rightSlot?: React.ReactNode,
    mobile?: React.ReactNode,
    hideMobile?: boolean,
    onMobile?: () => void,
}

function StorageFilters({ mobile, rightSlot, hideMobile, onMobile, ...props }: StorageFiltersProps) {
    const { children } = props;

    return (
        <div className="storage__filters">
            <div className="storage__filters-left">
                {children}
            </div>
            <div className="storage__filters-right">
                {rightSlot}
            </div>
            {!hideMobile && (
                <div className="storage__filters-mob">
                    {mobile}
                    <button className="storage__filters-mob-filter" onClick={onMobile}>
                        <MobileFilterIcon />
                    </button>
                </div>
            )}
        </div>
    );
}

export default StorageFilters;
